import { Component, ViewChild,Input,Output, EventEmitter, effect, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { EmployeeModel } from 'app/model/employee.model';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import { FilterModel } from './filter.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { ContextMenuComponent } from 'app/components/contex-menu/context-menu.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core'; // El módulo que maneja el ripple




@Component({
  selector: 'app-setting-field-salary',
  templateUrl: 'setting-field-salary.component.html',
  styleUrl: 'setting-field-salary.component.css',
  standalone: true,
  imports: [CdkDropList,
    CdkDrag,
    MatTableModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatRippleModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ContextMenuComponent, CommonModule
  ],
  providers: [NgbModal],
})
export class SettingFieldSalaryComponent {
  @Input() employeeType!: number;
  @Input() year!: number;
  @Input() version!: number;
  @Input() budgetEmployeeType!: any[];
  @Input() fundCode!: number;
  @Output() activeChange = new EventEmitter<boolean>();
  @ViewChild('table', { static: true }) table: MatTable<any>;
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild(ContextMenuComponent) contextMenu!: ContextMenuComponent;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  public salaryService = inject(BudgetGenerateService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public accountPlanVersion: { [key: string]: any[] } = {};
  private timeout: any;
  public dataSource;
  public formAccountPlanVersion: FormGroup;
  public account;
  displayedColumns: string[] = ['order',
    'isActive',
    'accountCode',
    'displayName',
    'fmrApplied',
    'isTaxable',
    'hint',
    'calculation',
    'block',
    'setting'];
  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) {

    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
        this.getAccountPlanVersion();
        this.getAccount();
        this.formAccountPlanVersion.get('entityCode').patchValue(this.entitySelected?.code);
        
      }

    })


  }


  /**crear formulario reactivo diverso*/
  createFormAccount() {
    this.formAccountPlanVersion = this.formBuilder.group({
      accountCode: [undefined, [Validators.minLength(3)]],
      displayName: ['', [Validators.required, Validators.minLength(3)]],
      hint: [''],
      calculation: [''],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      employeeType: ['', [Validators.required]],
      fundCode: ['', [Validators.required]],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });
  }


  /**oculta el menu contextual al hacer scroll */
  onTableScroll() {
    this.contextMenu.hide();
    this.dataSource.forEach(element => {
      element.isEditingHint = false;
      element.isEditingType = false;
      element.isEditingCal = false;
    });
  }

  /**agrega al menu contextual */
  block(account){
    return {
      label: account.block ? 'Desbloquear Edición' : 'Bloquear Edición',
      icon: account.block ? 'fa-solid fa-lock-open' : 'fa-solid fa-lock',
      onClick: () => this.toggleBlockAccount(account)
    };
  }
  
  /**agrega al menu contextual */
  blockMissionary(account){
    return {
      label: account.missionaryBlock ? 'Desbloquear Edición a Misioneros' : 'Bloquear Edición a Misioneros',
      icon: account.missionaryBlock ? 'fa-solid fa-lock-open' : 'fa-solid fa-lock',
      onClick: () => this.toggleBlockMissionary(account)
    };
  }

  accountType(account,actions){
    if(account.accountType!=0){
      actions[actions.length]={ 
        label: 'Eliminar',
        icon:'fa-solid fa-trash',  
        onClick: () => this.deleteAccountPlan(account) 
      };
    }
    return actions  
 
  }

  toggleBlockAccount(account) {   
    account.block= !account.block; 
    this.updateAccountPlanCheck(account,'block',account.block)
   
  }
  
  toggleBlockMissionary(account) {
    account.missionaryBlock = !account.missionaryBlock;
    this.updateAccountPlanCheck(account,'missionaryBlock',account.missionaryBlock)    
    
  }

  /**activa el menu contextual al click derecho  */
  onRightClick(event: MouseEvent, account) {
    let actions = [
      { label: 'Agregar Columna de Calculo',icon:'fa-solid fa-calculator',  onClick: () => this.newColumn(account) }
    ];
    actions[1]=this.block(account);
    actions[2]=this.blockMissionary(account);
    actions=this.accountType(account,actions);
    event.preventDefault();
    const offsetX = event.offsetX;
    const offsetY = event.offsetY;
    const targetElement = event.currentTarget as HTMLElement;
    const adjustedX = offsetX + targetElement.getBoundingClientRect().left;
    const adjustedY = offsetY + targetElement.getBoundingClientRect().top;
    this.contextMenu.actions = actions;
    this.contextMenu.show(adjustedX, adjustedY);
  }


 randomNumber() {
    return Math.floor(Math.random() * 1000) + 1;
  }

  /** Genera un código único que no existe en los registros */
generateCode() {
  let code;
  do {
    code = 'aux_' + this.randomNumber(); 
  } while (!this.findAcountPlan(code)); 

  return code;
}

  /**nueva columna calculada */
  newColumn(account) {
    let column = {}
    let code = this.generateCode();
    column['accountCode'] = code;
    column['entityCode'] = account.entityCode;
    column['hint'] = 'Columna de calculo de ' + account.displayName;
    column['displayName'] = 'Columna de calculo de ' + account.displayName;
    column['employeeType'] = account.employeeType;
    column['year'] = account.year;
    column['version'] = account.version;
    column['accountType'] = 2; 
    column['isTaxable'] = 0;
    column['fmrApplied'] = 0;
    column['block'] = 0;
    column['fundCode'] = this.fundCode;
    column['order'] = account.order ;
    this.salaryService.saveSalaryPlanVersion(column).subscribe(res => {
      this.getAccountPlanVersion();
      this.notification('Cuenta guardada exitosamente');
    })
  }



  // Cierra el menú si haces clic en cualquier otro lugar
  @HostListener('document:click')
  clickAnywhere() {
    if (this.contextMenu.visible) {
      this.contextMenu.hide();
    }
  }


  /**Activa el input y le da el foco */
  enableEditing(element, field) {
    element['isEditing' + field] = true;
    this.cdr.detectChanges();
    setTimeout(() => {
      const input = this.inputs.toArray()[0];
      if (input && input.nativeElement) {
        input.nativeElement.focus();
      }
    }, 0);
  }


  /**Ajusta el alto de scroll y la posicion de del input en relacion a la posicion del contenedor */
  autoGrow(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = textArea.scrollHeight + 2 + 'px';
    textArea.style.top = newTop + 'px';
    textArea.style.left = topParent.left + 'px';
  }

  /**Ajusta el alto y la posicion de del input a la posicion del contenedor */
  autoTop(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = 55 + 'px';
    textArea.style.top = newTop + 'px';
  }


  /**mueve la fila y ejecuta el metodo para actualizar el nuevo orden */
  drop(event: CdkDragDrop<string>) {
    const previousIndex = this.dataSource.findIndex(d => d === event.item.data);
    moveItemInArray(this.dataSource, previousIndex, event.currentIndex);
    this.updateOrder(this.dataSource)
    this.table.renderRows();
    this.notification('Datos Actualizados');
  }

  getAccountPlanWithTime() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getAccountPlanVersion();
    }, 5000);
  }

  /**Metodo para actualizar el orden del plan de cuenta */
  updateOrder(data) {
    data.map((account, index) => {
      let ordenAccount = this.setAccount(account.accountCode)
      ordenAccount.order = index + 1
      this.salaryService.updateSalaryPlanVersion({ id: account.id, order: index + 1 }).subscribe(res => {

      })
    })
  }


  setAccount(accountCode) {
    return this.dataSource.find(acc => acc.accountCode == accountCode);
  }


  /**Actualiza el account plan version*/
  updateAccountPlan(data, field, newValue) {
    clearTimeout(this.timeout);
    let account = this.setAccount(data.accountCode)
    if (account[field] != newValue) {
      account[field] = newValue
      this.salaryService.updateSalaryPlanVersion({ id: data.id, [field]: newValue }).subscribe(res => {
        this.notification('Datos Actualizados');
      })
    }
  }


    /**Actualiza el account plan version*/
    updateAccountPlanCheck(data, field, newValue) {
        this.salaryService.updateSalaryPlanVersion({ id: data.id, [field]: newValue }).subscribe(res => {
          this.notification('Datos Actualizados');
        })
    }



  /**Elimina un account plan version*/
  deleteAccountPlan(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar la cuenta ' + params.accountCode + ' ' + params.displayName + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.salaryService.deleteSalaryPlanVersion({ id: params.id }).subscribe(res => {
          this.notification('Cuenta ' + params.account_code + ' ' + params.displayName + 'eliminada ');
          this.getAccountPlanVersion();
        })

      }
    })



  }

  ngOnInit() {
    /**aqui podemos recibir los valores desde la tabla budget_version */
    this.filter.year = this.year;
    this.filter.version = this.version;
    this.createFormAccount();
    this.formAccountPlanVersion.get('year').patchValue(this.filter.year);
    this.formAccountPlanVersion.get('version').patchValue(this.filter.version);
    this.formAccountPlanVersion.get('employeeType').patchValue(this.employeeType);
    this.formAccountPlanVersion.get('fundCode').patchValue(this.fundCode);
    
  }




  /**trae el plan de cuentas */
  getAccountPlanVersion() {
    this.salaryService.getSalaryPlanVersion(this.filter).subscribe(res => {
      this.budgetEmployeeType.forEach(b => {
        this.accountPlanVersion[b.employeeType] = res.filter(r => r.employeeType === b.employeeType && r.fundCode === this.fundCode)
      })
      this.dataSource = this.accountPlanVersion[this.employeeType];
    })
  }


  /**trae las cuentas */
  getAccount() {
    delete this.filter.typeId;
    this.salaryService.getAasinetAccount({code:'411'}).subscribe(res => {
      this.account = this.mapSelect(res)
    })
  }


  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {    
    this.resetForm();
    this.formAccountPlanVersion.get('employeeType').patchValue(this.employeeType);
    this.formAccountPlanVersion.get('fundCode').patchValue(this.fundCode);
    this.formAccountPlanVersion.get('year').patchValue(this.year);
    this.formAccountPlanVersion.get('version').patchValue(this.version);
    this.open(this.modalAccount)
  }

  changeEmployeeType() {
    this.dataSource = this.accountPlanVersion[this.employeeType];
    this.formAccountPlanVersion.get('employeeType').patchValue(this.employeeType);
  }

  /**busca los las cuentas q no existen  */
  findAcountPlan(code): boolean {
    let r = false;
    try {
      r = !this.accountPlanVersion[this.employeeType].some((a) => a.accountCode == code);
    }
    catch {
    }
    return r
  }


  /**busca los las cuentas q existen  */
  findAcount(code): boolean {
    return this.dataSource.some((a) => a.accountCode == code);
  }



  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
  mapSelect(data) {
    data=data.filter(d=>d.acceptEntries)
    let newData = data.map((d) => {
      const name = d.name
      const isActive = this.findAcountPlan(d.code)
      return {
        code: d.code,
        nameCode: d.code + ' - ' + name,
        name: name,
        disabled: !d.acceptEntries,
        isActive: d.acceptEntries
      }
    });
    return newData
  }


 

  resetForm() {
    this.formAccountPlanVersion.patchValue({
      accountCode: undefined,
      displayName: undefined,
      hint: '',
      calculation: ''
    });
    this.formAccountPlanVersion.get('accountCode')?.markAsPristine();
    this.formAccountPlanVersion.get('displayName')?.markAsPristine();
    this.formAccountPlanVersion.get('hint')?.markAsPristine();
    this.formAccountPlanVersion.get('calculation')?.markAsPristine();
    this.formAccountPlanVersion.get('displayName')?.markAsUntouched();


  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNewAccount() {
    if (this.formAccountPlanVersion.valid) {
      this.salaryService.saveSalaryPlanVersion(this.formAccountPlanVersion.value).subscribe(res => {
        this.getAccountPlanVersion();
        this.close();
        this.resetForm();
        this.notification('Cuenta guardada exitosamente');
      })
    }
  }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



}


